// Configuration centrale des informations légales et institutionnelles de SecurePass.
//
// RÈGLE ABSOLUE : ne JAMAIS fabriquer une valeur inconnue.
// Toute information non confirmée par le projet doit rester `null` -> l'UI affiche alors
// le libellé localisé public:legalCommon.placeholder via <LegalValue> / <Placeholder>.
// Pays de l'éditeur et statut « version de travail » : libellés localisés (public:legalCommon).
//
// Les seules valeurs remplies ci-dessous sont celles déjà présentes et assumées dans le produit :
// le service s'appelle SecurePass et est exploité par doli.nc (Nouvelle-Calédonie).
// Tout le reste (forme juridique, capital, RIDET, RCS, adresse, représentant, contacts,
// hébergeur, localisation d'hébergement) reste à compléter avant la mise en production.

export const legal = {
  // --- Identité du service / éditeur ---
  serviceName: "SecurePass",
  publisherName: "doli.nc",

  // --- Informations légales (À COMPLÉTER — ne rien inventer) ---
  legalForm: null,          // ex. SARL, SAS, EURL...
  shareCapital: null,       // capital social
  ridet: null,              // n° RIDET (Nouvelle-Calédonie)
  rcs: null,                // registre du commerce
  registeredOffice: null,   // adresse du siège
  legalRepresentative: null, // responsable de publication / représentant légal

  // --- Contacts (À COMPLÉTER) ---
  contactEmail: null,
  privacyEmail: null,
  securityEmail: null,
  phone: null,

  // --- Hébergement (À COMPLÉTER — ne pas inventer la localisation des données) ---
  hostingProvider: null,
  hostingLocation: null,

  // --- Versions des documents (traçabilité) ---
  privacyVersion: "0.1",
  termsVersion: "0.1",
  legalVersion: "0.1",
  commercialTermsVersion: "0.1",
  dpaVersion: "0.1",
  lastUpdated: "2026-09",
};

// Renvoie true si l'information est réellement connue (non nulle, non vide).
export const isKnown = (v) => v !== null && v !== undefined && String(v).trim() !== "";

export default legal;
